<div class="p-col-12 p-grid p-jc-center">
  <div class="form-container p-card">
    <h2 i18n="login form header|Login form header@@login-form-header">Login</h2>
    <form class="p-fluid" [formGroup]="loginForm" (ngSubmit)="onSubmit()">
      <div class="p-field">
        <label for="username" i18n="login field label|Login field label@@login-field-label">Login</label>
        <input
          type="username"
          formControlName="username"
          pInputText
          [ngClass]="{ 'p-invalid': submitted && f.username.errors }"
        />
        <div *ngIf="submitted && f.username.errors" class="p-invalid">
          <div *ngIf="f.username.errors.required" i18n="field required error|Field is required@@field-required-error">Field is required</div>
        </div>
      </div>
      <div class="p-field">
        <label for="password" i18n="password field label|Password field label@@password-field-label">Password</label>
        <input
          type="password"
          formControlName="password"
          pPassword
          [feedback]="false"
          [ngClass]="{ 'p-invalid': submitted && f.password.errors }"
        />
        <div *ngIf="submitted && f.password.errors" class="p-invalid">
          <div *ngIf="f.password.errors.required" i18n="field required error|Field is required@@field-required-error">Field is required</div>
        </div>
      </div>
      <p-messages [(value)]="messages"></p-messages>
      <div class="p-field">
        <button *ngIf="!loading" pButton [disabled]="loading" i18n-label="login button|Login button@@login-button" label="Login"></button>
        <button *ngIf="loading" pButton [disabled]="loading" i18n-label="login button|Login button@@login-button" label="Login" icon="pi pi-spin pi-spinner" [iconPos]="'right'"></button>

        <!-- <button pButton i18n-label="login form register link|Login form register link@@register-link" label="Register" class="p-button-link" (click)="register()"></button> -->
      </div>
    </form>
  </div>
</div>
